export enum eTypeOperation {
  Interno = 1,
  Externo = 2,
  VentaEnVerde = 3
}
